import React from 'react';
import { holdSummary } from '../../../logic/withdrawalRequest';

// Top of the patient card while a request holds the patient; the topbar's WithdrawalHoldChip takes over once it scrolls out.
// Not the witems Alert: its link is URL-only, and this one opens the Withdraw window.
/** @param {{ requestedOn?: string | null, chartsLive?: boolean, onOpen?: () => void }} props */
export default function WithdrawalHoldBanner({ requestedOn = null, chartsLive = false, onOpen }) {
  return (
    <div className="withdrawal-hold-band" role="region" aria-label="Withdrawal hold">
      <span className="withdrawal-hold-band__icon" aria-hidden="true">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
          <line x1="9" y1="5" x2="9" y2="19" />
          <line x1="15" y1="5" x2="15" y2="19" />
        </svg>
      </span>
      <div className="withdrawal-hold-band__text">
        <span className="withdrawal-hold-band__title">
          Withdrawal requested{requestedOn ? ` on ${requestedOn}` : ''} · patient on hold
        </span>
        <span className="withdrawal-hold-band__body">{holdSummary(chartsLive)}</span>
      </div>
      <button type="button" className="withdrawal-hold-band__action" onClick={onOpen}>View request</button>
    </div>
  );
}
